import { useMapFilterChange } from './useMapFilterChange';

export default useMapFilterChange;
